import type { ReactNode } from 'react';

export const symbol_fiber_dvr: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M174-357h132q20 0 35-15t15-35v-146q0-20-15-35t-35-15H174q-6 0-10.5 4.5T159-588v216q0 6 4.5 10.5T174-357Zm35-50v-146h97v146h-97Zm270-21-49-160q-2-7-7.7-11t-13.3-4q-11 0-17 8t-3 19l57 202q2 8 8.32 12.5 6.33 4.5 14.76 4.5h13.49q8.43 0 14.93-4.5T506-374l63-199q4-11.35-3.45-20.68-7.44-9.32-19.17-9.32-8.38 0-14.88 5t-8.5 13l-44 157Zm176-18h58l27 74q2.47 7.06 8.24 11.03Q754-357 762-357q12 0 19.5-10.5T784-389l-23-62q17-4 29-16.5t12-28.5v-57q0-20-15-35t-35-15H620q-6 0-10.5 4.5T605-588v206q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08 7-7.09 7-17.92v-64Zm0-50v-57h97v57h-97ZM100-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h760q24.75 0 42.38 18Q920-764 920-740v520q0 24-17.62 42-17.63 18-42.38 18H100Zm0-60h760v-520H100v520Zm0 0v-520 520Z"
		/>
	</svg>
);
